import { useState, useRef, useEffect, useCallback } from 'react';
import { Icon } from '@iconify/react';
import ImgC1 from '../../assets/img/tecnologia/azure.png'
import ImgC2 from '../../assets/img/tecnologia/sqlserver.svg'
import ImgC3 from '../../assets/img/tecnologia/netcore.png'
import ImgC4 from '../../assets/img/tecnologia/react.png'
import ImgC5 from '../../assets/img/tecnologia/mysql.png'
import ImgC6 from '../../assets/img/tecnologia/vue.png'
import ImgC7 from '../../assets/img/tecnologia/aws.png'
import ImgC8 from '../../assets/img/tecnologia/postgresql.png'
import ImgC9 from '../../assets/img/tecnologia/nodejs.png'
import ImgC10 from '../../assets/img/tecnologia/Python-Logo.png'
import ImgC11 from '../../assets/img/tecnologia/swift_logo.png'
import ImgC12 from '../../assets/img/tecnologia/kotlin.png'
import ImgC13 from '../../assets/img/tecnologia/react-native.png'
import ImgC14 from '../../assets/img/tecnologia/next-js-logo.png'
import ImgC15 from '../../assets/img/tecnologia/logo_flutter.png'
import ImgC16 from '../../assets/img/tecnologia/mongodb.png'

const icons = [
  { img: ImgC1, label: 'Azure' },
  { img: ImgC2, label: 'SQL Server' },
  { img: ImgC3, label: '.NET Core' },
  { img: ImgC4, label: 'React' },
  { img: ImgC5, label: 'MySQL' },
  { img: ImgC6, label: 'Vue.js' },
  { img: ImgC7, label: 'AWS' },
  { img: ImgC8, label: 'PostgreSQL' },
  { img: ImgC9, label: 'Node.js' },
  { img: ImgC10, label: 'Python' },
  { img: ImgC11, label: 'Swift' },
  { img: ImgC12, label: 'Kotlin' },
  { img: ImgC13, label: 'React Native' },
  { img: ImgC14, label: 'Next.js' },
  { img: ImgC15, label: 'Flutter' },
  { img: ImgC16, label: 'MongoDB' },
];

const VISIBLE = 4;
const maxIndex = icons.length - VISIBLE;

export default function Carousel() {
  const [current, setCurrent] = useState(0);
  const trackRef = useRef<HTMLDivElement>(null);
  const dragging = useRef(false);
  const startX = useRef(0);
  const startScroll = useRef(0);
  const moved = useRef(false);

  const next = () => setCurrent(c => c < maxIndex ? c + 1 : 0);
  const prev = () => setCurrent(c => c > 0 ? c - 1 : maxIndex);

  const goTo = (i: number) => setCurrent(Math.max(0, Math.min(i, maxIndex)));

  const getOffset = () => {
    if (!trackRef.current) return 0;
    const itemW = trackRef.current.scrollWidth / icons.length;
    return itemW * current;
  };

  useEffect(() => {
    if (!trackRef.current) return;
    trackRef.current.scrollTo({ left: getOffset(), behavior: 'smooth' });
  }, [current]);

  const onPointerDown = (e: React.PointerEvent) => {
    if (!trackRef.current) return;
    dragging.current = true;
    moved.current = false;
    startX.current = e.clientX;
    startScroll.current = trackRef.current.scrollLeft;
    (e.currentTarget as HTMLElement).setPointerCapture(e.pointerId);
  };

  const onPointerMove = (e: React.PointerEvent) => {
    if (!dragging.current || !trackRef.current) return;
    const dx = e.clientX - startX.current;
    if (Math.abs(dx) > 5) moved.current = true;
    const itemW = trackRef.current.scrollWidth / icons.length;
    const index = Math.round((startScroll.current - dx) / itemW);
    setCurrent(Math.max(0, Math.min(index, maxIndex)));
  };

  const onPointerUp = () => {
    dragging.current = false;
  };

  useEffect(() => {
    const id = setInterval(() => {
      if (!dragging.current) next();
    }, 3000);
    return () => clearInterval(id);
  });

  return (
    <div className="relative max-w-5xl mx-auto select-none">
      <div
        ref={trackRef}
        className="overflow-hidden"
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
        style={{ cursor: dragging.current ? 'grabbing' : 'grab', touchAction: 'pan-y' }}
      >
        <div className="flex gap-4 md:gap-6">
          {icons.map((item, i) => (
            <div
              key={i}
              className="flex-shrink-0"
              style={{ width: `calc((100% - ${(VISIBLE - 1) * 1.5}rem) / ${VISIBLE})` }}
            >
              <div className="flex items-center justify-center p-5 md:p-7 bg-white rounded-xl border border-black/10 hover:shadow-sm transition-shadow h-full">
                <img src={item.img} className="w-full max-w-[160px] h-auto opacity-60 hover:opacity-100 transition-all" style={{ filter: 'contrast(0)' }} alt={item.label} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-10 h-10 rounded-full bg-[#f26724] flex items-center justify-center text-white hover:bg-[#f3823c] transition-all shadow-lg z-10"
      >
        <Icon icon="mdi:chevron-left" className="text-xl" />
      </button>
      <button
        onClick={next}
        className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-10 h-10 rounded-full bg-[#f26724] flex items-center justify-center text-white hover:bg-[#f3823c] transition-all shadow-lg z-10"
      >
        <Icon icon="mdi:chevron-right" className="text-xl" />
      </button>

      <div className="flex justify-center gap-2 mt-6">
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2 h-2 rounded-full transition-all ${i === current ? 'bg-[#f26724] w-6' : 'bg-gray-300 hover:bg-gray-400'}`}
          />
        ))}
      </div>
    </div>
  );
}
